import { createContext, useState } from 'react';

import { Patient } from 'pages/PatientList/types';

import { patientObject } from '../constants';

import {
  DrawerInviteScheduleContextData,
  DrawerInviteScheduleProviderProps,
  ErrorProps,
} from '../types';

export const DrawerInviteScheduleContextDefaultValues: DrawerInviteScheduleContextData =
  {
    date: null,
    setDate: () => null,
    isChecked: false,
    setIsChecked: () => false,
    hour: null,
    setHour: () => null,
    error: {
      isDateError: false,
      isTimeError: false,
    },
    setError: () => null,
    patient: patientObject,
    setPatient: () => null,
    step: 1,
    setStep: () => null,
    isTermsChecked: false,
    setIsTermsChecked: () => false,
  };

export const DrawerInviteScheduleContext = createContext(
  DrawerInviteScheduleContextDefaultValues,
);

export function DrawerInviteScheduleProvider({
  children,
}: DrawerInviteScheduleProviderProps) {
  const [date, setDate] = useState<Date | null>();
  const [isChecked, setIsChecked] = useState(false);
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [hour, setHour] = useState<Date | null>();
  const [patient, setPatient] = useState<Patient>(patientObject);
  const [step, setStep] = useState(1);
  const [error, setError] = useState<ErrorProps>({
    isDateError: false,
    isTimeError: false,
  });

  return (
    <DrawerInviteScheduleContext.Provider
      value={{
        date,
        setDate,
        isChecked,
        setIsChecked,
        hour,
        setHour,
        patient,
        setPatient,
        step,
        setStep,
        error,
        setError,
        isTermsChecked,
        setIsTermsChecked,
      }}
    >
      {children}
    </DrawerInviteScheduleContext.Provider>
  );
}
